import I18n from 'app/i18n';

interface OtherItemDescriptionProps {
    description: string;
    content_langs?: {[key: string]: string};
}

export const otherItemDescription = (artifact: OtherItemDescriptionProps): string => {
    const {content_langs, description} = artifact;

    return content_langs && content_langs[I18n.locale] || description;
};
